import { render, staticRenderFns } from "./ClinicFinanceTransfers.vue?vue&type=template&id=d4880854"
import script from "./ClinicFinanceTransfers.vue?vue&type=script&lang=js"
export * from "./ClinicFinanceTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports